import axios from 'axios';
import qs from 'qs';
import {Message} from "element-ui";

import router from '../router';
import {API_URL} from "../common/config";

// 检测父页面域名
let htmlAnchorElement = document.createElement('a');
htmlAnchorElement.href = API_URL;
let baseURL = htmlAnchorElement.origin;
if (!baseURL) {
    baseURL = htmlAnchorElement.protocol + "//" + htmlAnchorElement.hostname + (htmlAnchorElement.port ? ':' + htmlAnchorElement.port: '');
}
const instance = axios.create({
    baseURL: baseURL,  // 为所有 HTTP 请求 URL 添加前缀
    withCredentials: true,
    transformRequest: [function (data) {
        data = qs.stringify(data);
        return data;
    }],
});

instance.interceptors.request.use(config => {
    if (localStorage.token) {
        config.headers.Token = encodeURI(localStorage.token);
    }
    return config;
}, err => {
    return Promise.reject(err);
});

instance.interceptors.response.use(response => {
    // if (response.data.Status !== "1") {
    //     Message.error(response.data.Message);
    // }
    let token = response.headers.token;
    if (token) {
        localStorage.token = token;
    }
    return response;
}, error => {
    if (error.response) {
        if (error.response.status === 401) {
            localStorage.token = null;
            router.replace({
                path: '/login',
                query: {redirect: router.currentRoute.fullPath}
            });
        }
    }
    return Promise.reject(error);
});

export default instance;